


















































import { Vue, Component, PropSync, Ref, Prop } from 'vue-property-decorator';
import { PlatformDisplayInfo, YorN } from 'ncp-api-supporter';
import RadioGroup from '@/pro/components/common/RadioGroup.vue';
@Component({
  components: { RadioGroup },
})
export default class PlatformDisplay extends Vue {
  @PropSync('platformDisplayInfo')
  private platformDisplayInfoSync!: PlatformDisplayInfo;
  @Prop({ required: true })
  private readonly disabled: boolean;

  private radioOption = {
    name: 'platformDisplayYn',
    data: [
      {
        id: 'PRO_PRODUCT_ADD_PLATFORM_DISPLAY_ALL',
        name: 'platformDisplayYn',
        value: 'Y',
        display: 'PRO_PRODUCT_ADD_PLATFORM_DISPLAY_ALL',
      },
      {
        id: 'PRO_PRODUCT_ADD_PLATFORM_DISPLAY_SETTING',
        name: 'platformDisplayYn',
        value: 'N',
        display: 'PRO_PRODUCT_ADD_PLATFORM_DISPLAY_SETTING',
      },
    ],
  };

  @Ref()
  private readonly platformRef: RadioGroup;
  public focus(): void {
    this.platformRef.focus();
  }

  private changePlatFormDisplayType(curr: YorN): void {
    curr === 'N' && this.initializeData();
  }

  private initializeData(): void {
    this.platformDisplayInfoSync.pcYn = 'Y';
    this.platformDisplayInfoSync.mobileWebYn = 'Y';
    this.platformDisplayInfoSync.mobileYn = 'N';
  }
}
